import { OdorDetectionInfos } from './definitions';
import { DEFAULT_ODOR_PRESENCE_DEACTIVATION_PERCENT_OF_MAX_VALUE } from '../serial/constants';
import { DEFAULT_PLOT_DECIMATED_FPS } from '../../utils/constants/constants';
import { mean, standardDeviation } from './utils';

const NOISE_MULTIPLYING_FACTOR = 20;
const NOISE_READY_THRESHOLD = 2;

export enum QuestioningState {
  SensorCleaning = 'SensorCleaning',
  BaselineRecording = 'BaselineRecording',
  AnalyteRecording = 'AnalyteRecording',
}

export const initOdorDetectionInfos = (): OdorDetectionInfos => {
  return { isOdorPresent: false, noizeLevel: 0, thresholdLevel: 0, maxIntensity: 0, startTimestamp: 0, stopTimestamp: 0, lastRecognitionTimestamp: 0 };
};

// tooling for state machine
export interface QuestioningStateInfo {
  state: QuestioningState;
  noizeLevel: number;
  thresholdLevel: number;
  maxIntensity: number;
  startTimestamp: number;
}

export const initQuestioningStateInfos = (): QuestioningStateInfo => {
  return { state: QuestioningState.BaselineRecording, noizeLevel: 0, thresholdLevel: 0, maxIntensity: 0, startTimestamp: 0 };
};

export const updateStateFixedAnalyteDuration = (stateInfo: QuestioningStateInfo, averageMZI: number, averageMZISeries: number[], analyteDuration: number) => {
  let noizeSeries = averageMZISeries.slice(-4 * DEFAULT_PLOT_DECIMATED_FPS, -1 * DEFAULT_PLOT_DECIMATED_FPS);
  stateInfo.noizeLevel = mean(noizeSeries) + standardDeviation(noizeSeries) * NOISE_MULTIPLYING_FACTOR; // to do : provide slider to adjust this value

  // ---------------- BASELINE ------------------
  // --------------------------------------------
  if (stateInfo.state === QuestioningState.BaselineRecording) {
    // odor not present : compute noise and evaluate current mzi versus noise
    // console.log('noizeLevelRef.current is', noizeLevelRef);

    // transition baseline --> analyte
    if (stateInfo.noizeLevel > 0 && averageMZI > stateInfo.noizeLevel) {
      let previousFrameMean: number = averageMZISeries[averageMZISeries.length - 2];
      stateInfo.thresholdLevel = mean([previousFrameMean, averageMZI]);
      stateInfo.state = QuestioningState.AnalyteRecording;
      stateInfo.startTimestamp = Date.now();
      console.log('odor is detected and question state is changed');
    }
  }

  // ---------------- ANALYTE ------------------
  // -------------------------------------------
  if (stateInfo.state === QuestioningState.AnalyteRecording) {
    stateInfo.maxIntensity = Math.max(stateInfo.maxIntensity, averageMZI);

    // transition analyte --> cleaning
    if (stateInfo.startTimestamp > 0 && Date.now() - stateInfo.startTimestamp > analyteDuration * 1000) {
      stateInfo.state = QuestioningState.SensorCleaning;
      stateInfo.startTimestamp = 0;
    }
  }

  // ---------------- CLEANING ------------------
  // --------------------------------------------
  if (stateInfo.state === QuestioningState.SensorCleaning) {
    // transition cleaning --> baseline
    if (averageMZI < Math.max(stateInfo.maxIntensity * DEFAULT_ODOR_PRESENCE_DEACTIVATION_PERCENT_OF_MAX_VALUE, stateInfo.thresholdLevel) && stateInfo.noizeLevel < NOISE_READY_THRESHOLD) {
      stateInfo.maxIntensity = 0;
      stateInfo.thresholdLevel = 0;
      stateInfo.state = QuestioningState.BaselineRecording;
    }
  }
};
